export const getStoplist = store => store.stoplist
